// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import {
    TrackEventBaseParameters,
    TrackEventParameters,
} from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

export type TrackEventListParameters<
    PartialProps extends keyof TrackEventParameters<Item, Model> | null = null,
    RequiredProps extends keyof TrackEventParameters<Item, Model> | null = null,
    Item = Toolkit.GoogleAnalytics.AnyItem,
    Model = Toolkit.GoogleAnalytics.MapperModel,
> = TrackEventBaseParameters<
    "item_list_id" | "item_list_name" | "currency" | "value" | (PartialProps extends null ? never : PartialProps),
    "items" | (RequiredProps extends null ? never : RequiredProps),
    Item,
    Model
>;

const trackEventList = <T extends TrackEventListParameters<any, any, any, any>>(
    parameters: T,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event(parameters, { requireItems: true, ...options });
};

export default trackEventList;
